import { CartAddEvent } from '@theme/events';

/**
 * BEKRA cart drawer upsell: adds one unit of a recommended product via the
 * Shopify AJAX cart and hands the result to Horizon through its own
 * CartAddEvent, so the drawer (section morph) and the header cart counter
 * update exactly like a normal add to cart. No separate cart state.
 */
class BekraCartUpsell extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  /** @param {MouseEvent} event */
  #onClick = async (event) => {
    const target = /** @type {HTMLElement} */ (event.target);
    const button = /** @type {HTMLButtonElement | null} */ (target.closest('button[data-variant-id]'));
    if (!button || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    const sectionIds = [...document.querySelectorAll('cart-items-component')]
      .map((element) => (element instanceof HTMLElement ? element.dataset.sectionId : ''))
      .filter(Boolean);

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
          sections: sectionIds.join(','),
        }),
      });
      const data = await response.json();
      if (data.status) throw new Error(data.description || data.message);

      const cart = await (await fetch(`${Theme.routes.cart_url}.js`, { headers: { Accept: 'application/json' } })).json();

      button.classList.remove('is-loading');
      button.classList.add('is-added');
      const status = this.querySelector('[data-upsell-status]');
      if (status) status.textContent = button.dataset.addedText || '';

      // Short visible confirmation before the drawer re-renders without this product.
      await new Promise((resolve) => setTimeout(resolve, 650));

      this.dispatchEvent(
        new CartAddEvent({}, String(button.dataset.variantId), {
          source: 'bekra-cart-upsell',
          itemCount: cart.item_count,
          productId: button.dataset.productId,
          sections: data.sections,
        })
      );
    } catch (error) {
      console.error(error);
      button.disabled = false;
      button.classList.remove('is-loading');
      button.removeAttribute('aria-busy');
      const status = this.querySelector('[data-upsell-status]');
      if (status) status.textContent = button.dataset.errorText || '';
    }
  };
}

if (!customElements.get('bekra-cart-upsell')) {
  customElements.define('bekra-cart-upsell', BekraCartUpsell);
}
